import { createContext, useContext, useState, useEffect } from "react";
import { Toast } from "../components/Toast/Toast";

export const ToastContext = createContext(null);

export const ToastProvider = ({ children, ...props }) => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const handleGlobalToast = (e) => {
      setMessages((arr) => [...arr, { ...e.detail, key: Date.now() }]);
    };
    window.addEventListener("globalToast", handleGlobalToast);
    return () => window.removeEventListener("globalToast", handleGlobalToast);
  }, []);

  const removeMessage = (key) =>
    setMessages((arr) => arr.filter((m) => m.key !== key));

  return (
    <ToastContext.Provider
      value={{
        addMessage(message) {
          setMessages((arr) => [...arr, message]);
        },
      }}
    >
      {children}
      {messages.map((m) => (
        <Toast
          key={m.key}
          message={m}
          onExited={() => removeMessage(m.key)}
          {...props}
        />
      ))}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const { addMessage } = useContext(ToastContext);

  const show = (message, options) => {
    addMessage({ message, ...options, key: new Date().getTime() });
  };

  return {
    show,
    info(message, options) {
      show(message, { severity: "info", ...options });
    },
    success(message, options) {
      show(message, { severity: "success", ...options });
    },
    warning(message, options) {
      show(message, { severity: "warning", ...options });
    },
    error(message, options) {
      show(message, { severity: "error", ...options });
    },
  };
};
